exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-backup-container[data-v-76f49eb5]{margin:.75rem}.upload-backup-container>div.img-container[data-v-76f49eb5]{margin:.75rem;display:flex;justify-content:center;align-items:center}.upload-backup-container>div.img-container>img[data-v-76f49eb5]{width:100px}.upload-backup-container>button[data-v-76f49eb5]{margin-top:.75rem}", ""]);

// exports
